<template>
	<div class="comments-items">
		<UserTitle
			:border="true"
			:tab="true"
			:tabList="tabList"
			:active="active"
			:tabClick="tabClick"
		></UserTitle>
		<div class="spin-margin" v-if="loading">
			<a-spin>
				<a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
			</a-spin>
		</div>
		<div v-if="!loading">
			<div
				class="content"
				v-if="projectData.data && projectData.data.length > 0"
			>
				<b-row class="new-project">
					<div
						class="projects"
						v-for="(item, index) in projectData.data"
						:key="index"
					>
						<div class="project-content" v-if="item.project">
							<div class="projects-text">
								<h6 class="maxLength-text-1">{{ item.project.name }}</h6>
								<div class="flex-text">
									<div class="projects-flex-text">
										<span>项目类型</span>
										<Category :categoryId="item.project.categoryId"></Category>
									</div>
									<div class="projects-flex-text">
										<span>项目行业</span>
										<p v-if="item.project.industry">
											{{
												item.project.industry ? item.project.industry.name : ''
											}}
										</p>
									</div>
									<div class="projects-flex-text">
										<span>开始时间</span>
										<p>
											{{
												changeDataTime(item.project.startDate)
													? changeDataTime(item.project.startDate)
													: ''
											}}
										</p>
									</div>
									<div class="projects-flex-text">
										<span>状态</span>
										<p>
											{{
												{
													wait: '申请中',
													checked: '已初审',
													rechecked: '已复审',
													confirmed: '已通过',
													rejected: '已拒绝',
												}[item.status]
											}}
										</p>
									</div>
								</div>
							</div>
							<div style="display:flex;flex-wrap: wrap">
								<div class="projects-footer">
									<i></i>
									<span v-if="item.project.customer">
										{{ item.project.customer.name }}
									</span>
								</div>
								<div class="projects-footer">
									<i></i>
									<span v-if="item.project">
										{{
											item.project.areas && item.project.areas.length > 0
												? existData(item.project.areas[0], 'provinceName', '')
												: ''
										}}
										{{
											item.project.areas[0] && item.project.areas[0].length > 0
												? existData(item.project.areas[0], 'cityName', ' - ')
												: ''
										}}
									</span>
								</div>
							</div>
						</div>
						<div class="projects-contexts">
							<p class="maxLength-text-2">
								{{ onDesc(item.project.projectDesc) }}
							</p>
							<a @click="ProjectDetail(item.project.id)">
								查看详情
								<i></i>
							</a>
						</div>
					</div>
				</b-row>
				<b-pagination
					v-if="page.show"
					class="solution-page"
					style="justify-content: center;"
					v-model="page.current"
					:total-rows="page.rows"
					:perPage="page.perPage"
					first-number
					last-number
				></b-pagination>
			</div>
			<a-empty class="empty" description="暂无项目" v-else />
		</div>
	</div>
</template>
<script>
import Api from '@/apis'
import publicChange from '@/assets/js/index.js'
import Category from '@/components/category.vue'
export default {
	data() {
		return {
			active: 0,
			tabList: ['申请的项目', '参与的项目'],
			page: {
				current: 1,
				rows: 1,
				perPage: 10,
				show: false,
			},
			categoriesId: 0,
			projectData: [],
			loading: false,
		}
	},
	watch: {
		'page.current': {
			handler: function() {
				if (this.active == 0) {
					this.getProjectMine(true)
					window, scrollTo(0, 0)
				} else {
					this.getProjectMine()
					window, scrollTo(0, 0)
				}
			},
		},
	},
	mounted() {
		this.getProjectMine(true)
	},
	components: {
		Category,
	},
	methods: {
		login() {
			return publicChange.userLogin()
		},
		//获取我的项目
		async getProjectMine(type) {
			const login = this.login()
			if (login) {
				this.loading = true
				if (type) {
					try {
						const query = {
							current: this.page.current,
							pageSize: this.page.perPage,
							filters: {
								recommend: 1,
							},
						}
						const data = await Api.Project.getProjectMine(query)
						if (data.data && data.data.length > 0) {
							this.page.show = true
						} else {
							this.page.show = false
						}
						this.loading = false
						this.page.rows = data.total
						this.projectData = data
					} catch (e) {
						this.$Message.error(e)
					}
				} else {
					try {
						const query = {
							current: this.page.current,
							pageSize: this.page.perPage,
						}
						const data = await Api.Project.getProjectMine(query)
						if (data.data && data.data.length > 0) {
							this.page.show = true
						} else {
							this.page.show = false
						}
						this.loading = false
						this.page.rows = data.total
						this.projectData = data
					} catch (e) {
						this.$Message.error(e)
					}
				}
			}
		},
		onDesc(text) {
			return publicChange.disposeHtml(text)
		},
		//转换时间戳
		changeDataTime(date) {
			let time = new Date(date)
			return this.$moment(time).format('YYYY.MM.DD')
		},
		getImgUrl(img) {
			return publicChange.getStaticUrl(img)
		},
		existData(data, index, text) {
			return publicChange.existData(data, index, text)
		},
		_isMobile() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			return flag
		},
		//切换
		tabClick(item, index) {
			this.active = index
			if (index == 0) {
        this.page.current = 1
				this.getProjectMine(true)
				
			} else {
        this.page.current = 1
				this.getProjectMine()
			}
		},
		ProjectDetail(id) {
			const login = this.login()
			if (login) {
				this.$router.push({
					path: `/product/projectDetails`,
					query: {
						id: id,
					},
				})
			} else {
				this.$router.push({
					path: '/login',
					query: {
						redirect: `/product/projectDetails?id=${id}`,
					},
				})
				this.$message.warning('请先登录')
			}
		},
	},
}
</script>
<style scoped>
.comments-items .new-project {
	margin-top: 52px !important;
}
.comments-items .projects {
	margin: 0px 21px 34px 21px;
}
.comments-items .project-content {
	padding: 0 !important;
}
.comments-items .solution-page {
	margin-bottom: 30px;
	margin-top: 30px;
}
.comments-items h6 {
	font-size: 22px;
	font-weight: 400;
	color: #333333;
	line-height: 33px;
}
.comments-items .projects-footer:nth-child(1) {
	display: none;
}
</style>
